import { FileStarFourPointsIcon } from './FileStarFourPointsIcon';

/**
 * author: Jeff Anders
 * id E78BF233-EE37-492B-8E41-3965576E4A7C
 * name file-star-four-points
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-star-four-points.svg
 * tags
 * - Files / Folders 
 */
export const FileAutoIcon = FileStarFourPointsIcon;
export default FileAutoIcon